// Mirrors aws-lambda/shared/validate.mjs -> PASS_TYPES. Keep both in sync. Only passes we can confidently
// place against this app's 8 resorts (see src/data/resorts.js's `passes` field for the sourcing note) —
// deliberately no Indy Pass, its coverage here was ambiguous/unconfirmed when checked.
export const PASS_TYPES = [
  { id: "epic", label: "Epic Pass" },
  { id: "ikon", label: "Ikon Pass" },
  { id: "mountain_collective", label: "Mountain Collective" },
  { id: "none", label: "Day tickets / other" },
];

export const PASS_TYPE_LABELS = Object.fromEntries(PASS_TYPES.map((p) => [p.id, p.label]));
